import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RedeliveryRoutes } from '@shared/enums/app-routes.enum';
import { RedeliveryRolesService } from '@shared/services/user-role/redelivery-tab/redelivery-roles.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AllowAccessToUiGuard implements CanActivate {

  constructor(
    private router: Router,
    private redeliveryRolesService: RedeliveryRolesService,
  ) {}

  canActivate(): Observable<boolean> {
      return this.redeliveryRolesService.loggedUserRoles$.pipe(
        filter(user => !!user),
        map(() => {
          const allowAccessToTheUi = this.redeliveryRolesService.allowAccessToTheUi();
    
          if (!allowAccessToTheUi) {
            console.info(`Info: You can't access to the UI because you don't have a valid role`);
            this.router.navigate([`/${RedeliveryRoutes.deny}`]);
          }
      
          return allowAccessToTheUi;
        })
      );
  }
  
}
